<template>
    <div class="contacts-detail">
        <slot />

        <div class="contacts-detail__container">
            <div class="row" v-if="data && data.properties && data.properties.length">
                <div
                    class="col-default-4 col-tablet-6 col-v-tablet-12 contacts__col"
                    v-for="(itemA, indexA) in data.properties"
                    :key="indexA"
                    v-if="isCardShown(itemA)"
                >
                    <z-card class="contacts__card" theme="contact">
                        <template v-slot:title>
                            <h4 class="u-top-margin--no" v-html="itemA.name"></h4>
                        </template>
                        <template v-slot:content>
                            <div class="card-contact">
                                <div class="card-contact__footer card-contact__footer--no-divider">
                                    <span class="card-contact__item" v-if="itemA.value" v-html="itemA.value"></span>
                                    <span
                                        v-for="(itemB, indexB) in getArrayLink(itemA.items)"
                                        :key="`${itemB.type}-${indexB}`"
                                        class="card-contact__item"
                                    >
                                        <z-icon :name="itemB.type" width="24" height="24"></z-icon>
                                        <span>{{ itemB.key }}:&nbsp;</span>
                                        <z-link
                                            :href="`${setTypeLink(itemB.type)}:${itemB.value}`"
                                            theme="black"
                                        >
                                            {{ itemB.value }}
                                        </z-link>
                                    </span>
                                    <span
                                        v-for="(itemB, indexB) in getArrayText(itemA.items)"
                                        :key="`${itemB.type}-${indexB}`"
                                        class="card-contact__item"
                                    >
                                        <z-icon :name="itemB.type" width="24" height="24"></z-icon>
                                        <span>{{ itemB.key }}:&nbsp;</span>
                                        <span>{{ itemB.value }}</span>
                                    </span>
                                </div>
                            </div>
                        </template>
                    </z-card>
                </div>
            </div>

            <div class="row" v-if="data && data.people && data.people.length">
                <div
                    class="col-default-4 col-tablet-6 col-v-tablet-12 contacts__col"
                    v-for="(item, index) in data.people"
                    :key="index"
                >
                    <contacts-card :hidden-contacts="hiddenContacts" :data="item" />
                </div>
            </div>

            <div v-if="data && data.items && data.items.length">
                <z-accordion multiple auto-scroll>
                    <z-accordion-item
                        v-for="itemA in data.items"
                        :id="itemA.code"
                        :key="itemA.code"
                    >
                        <template v-slot:header>
                            <span v-html="itemA.name"></span>
                        </template>
                        <template v-slot:body>
                            <div
                                class="row"
                                v-if="itemA.properties && itemA.properties.length"
                            >
                                <div
                                    class="col-default-4 col-tablet-6 col-v-tablet-12 contacts__col"
                                    v-for="(itemB, indexB) in itemA.properties"
                                    :key="indexB"
                                    v-if="isCardShown(itemB)"
                                >
                                    <z-card class="contacts__card" theme="contact">
                                        <template v-slot:title>
                                            <h4 class="u-top-margin--no" v-html="itemB.name"></h4>
                                        </template>
                                        <template v-slot:content>
                                            <div class="card-contact">
                                                <div class="card-contact__footer card-contact__footer--no-divider">
                                                    <span class="card-contact__item" v-if="itemB.value" v-html="itemB.value"></span>
                                                    <span
                                                        v-for="(itemC, indexC) in getArrayLink(itemB.items)"
                                                        :key="`${itemC.type}-${indexC}`"
                                                        class="card-contact__item"
                                                    >
                                                        <z-icon :name="itemC.type" width="24" height="24"></z-icon>
                                                        <span v-if="itemC.key && itemC.key.length">{{ itemC.key }}:&nbsp;</span>
                                                        <z-link
                                                            :href="`${setTypeLink(itemC.type)}:${itemC.value}`"
                                                            theme="black"
                                                        >
                                                            {{ itemC.value }}
                                                        </z-link>
                                                    </span>
                                                    <span
                                                        v-for="(itemC, indexC) in getArrayText(itemB.items)"
                                                        :key="`${itemC.type}-${indexC}`"
                                                        class="card-contact__item"
                                                    >
                                                        <z-icon :name="itemC.type" width="24" height="24"></z-icon>
                                                        <span v-if="itemC.key && itemC.key.length">{{ itemC.key }}:&nbsp;</span>
                                                        <span>{{ itemC.value }}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </template>
                                    </z-card>
                                </div>
                            </div>

                            <div
                                class="row"
                                v-if="itemA.people && itemA.people.length"
                            >
                                <div
                                    class="col-default-4 col-tablet-6 col-v-tablet-12 contacts__col"
                                    v-for="(itemB, indexB) in itemA.people"
                                    :key="indexB"
                                >
                                    <contacts-card :hidden-contacts="hiddenContacts" :data="itemB" />
                                </div>
                            </div>

                            <div
                                class="contacts-detail-sections"
                                v-if="itemA.sections && itemA.sections.length"
                            >
                                <contacts-section
                                    :hidden-contacts="hiddenContacts"
                                    class="contacts-detail-sections__item u-bottom-margin--one-and-half"
                                    v-for="(itemB, indexB) in itemA.sections"
                                    :key="indexB"
                                    :data="{
                                        detail: itemB,
                                        list: itemA.sections
                                    }"
                                />
                            </div>
                        </template>
                    </z-accordion-item>
                </z-accordion>
            </div>
        </div>
    </div>
</template>

<script>
import ContactsSection from './Section.vue'

export default {
    name: 'contacts-detail',
    props: {
        data: [Array, Object],
        tab: {
            type: String,
            default: 'default'
        },
        hiddenContacts: {
            type: Boolean,
            default: false
        }
    },
    components: {
        ContactsSection
    },
    methods: {
        isCardShown (item) {
            let result = item.items.filter(prop => prop.value)

            return !!result.length
        },
        getArrayLink (data) {
            if (data && data.length) {
                return data.filter(item => {
                    return item.type === 'phone' || item.type === 'fax' || item.type === 'email'
                })
            }
        },
        getArrayText (data) {
            if (data && data.length) {
                return data.filter(item => {
                    return item.type !== 'phone' && item.type !== 'fax' && item.type !== 'email'
                })
            }
        },
        setTypeLink (type) {
            if (type === 'email') {
                return 'mailto'
            } else {
                return 'tel'
            }
        },
        imageUrl (data) {
            if (data && data.image) {
                return data.image
            }
            return '/images/user-default.png'
        }
    }
}
</script>

<style lang="scss">
</style>
